import LogoNewFile from '../assets/gsm_logo_new.png';

export function GSMCluster({width='30%'}){
    return (
        <div style={{padding: 8,width}}>
            <img src={LogoNewFile} alt={'logo'} width={'100%'} height={'auto'}/>
        </div>
    )
}